import firebase from 'firebase/compat';
const config = {

  apiKey: "AIzaSyCnU11ctFcr7vre9gUtUcyvKSbR-P8lwBA",
  authDomain: "setweb-api-9cb05.firebaseapp.com",
  projectId: "setweb-api-9cb05",
  storageBucket: "setweb-api-9cb05.appspot.com",
  messagingSenderId: "140133591912",
  appId: "1:140133591912:web:1ae764bacbf2b698a104dd",
  measurementId: "G-0X1713EHSP"

  };

firebase.initializeApp(config);
export const auth=firebase.auth;
export const db=firebase.firestore();